import type { ReportsTranslation } from './types';

/** Urdu. Pending review by native speakers. */
export const reportsUr: ReportsTranslation = {
  nav: 'رپورٹیں',
  title: 'رپورٹیں',
  description:
    'گفتگو کیسی رہی: تعداد، انسان کو منتقلی، حل اور فیڈبیک، ساتھ میں آپ کے پلان کا استعمال اور انوائسز۔ صرف مجموعی اعداد، پیغامات کا مواد کبھی نہیں۔',
  export: 'CSV ایکسپورٹ کریں',
  exported: 'CSV رپورٹ ڈاؤن لوڈ ہو گئی۔',
  loading: 'رپورٹ لوڈ ہو رہی ہے',
  tabs: {
    quality: 'سروس کا معیار',
    teams: 'ٹیم کی سرگرمی',
    tickets: 'ٹکٹ',
    ai: 'AI کا استعمال',
    billing: 'بلنگ',
  },
  withheld: 'روکا گیا',
  smallSample: 'چھوٹا نمونہ',
  fewer: 'روکا گیا: {{count}} سے کم',
  rateOf: '{{count}} میں سے {{rate}}',
  previousValue: 'پچھلی مدت: {{count}}',
  responses: 'جوابات: {{count}}',
  basedOn: 'ناپی گئی گفتگو: {{count}}',
  outOfFive: '{{value}} / 5',
  privacy:
    'رازداری کے تحفظ کے لیے، {{count}} سے کم گفتگو یا جوابات پر مبنی عدد روکا جاتا ہے، اور جہاں کُل اسے ظاہر کر دے وہاں اگلا سب سے چھوٹا عدد بھی۔',
  rangeNote: '{{from}} سے {{to}} تک، دن {{zone}} کے مطابق۔',
  partial:
    'اس مدت کا کچھ حصہ رپورٹوں کی ریکارڈنگ شروع ہونے سے پہلے کا ہے، اس لیے وہ شمار نہیں ہوتا۔',
  partialSince: 'رپورٹوں کی ریکارڈنگ {{date}} کو شروع ہوئی؛ اس سے پہلے کی گفتگو شمار نہیں ہوتی۔',
  filters: {
    range: 'تاریخیں',
    ranges: {
      '7d': 'پچھلے 7 دن',
      '30d': 'پچھلے 30 دن',
      '90d': 'پچھلے 90 دن',
      custom: 'اپنی مدت',
    },
    from: 'سے',
    to: 'تک',
    team: 'ٹیم',
    allTeams: 'تمام ٹیمیں',
    channel: 'چینل',
    allChannels: 'تمام چینل',
  },
  tiles: {
    conversations: 'گفتگو',
    handoffs: 'انسان کو منتقل',
    resolved: 'حل شدہ',
    feedback: 'گاہک کا فیڈبیک',
    aiResolved: 'AI نے حل کیں',
    firstResponse: 'پہلے جواب کا وسطانیہ',
    resolution: 'حل کے وقت کا وسطانیہ',
  },
  chart: {
    title: 'روزانہ گفتگو',
    summary:
      '{{from}} سے {{to}} تک روزانہ گفتگو کا لائن چارٹ، پچھلی مدت کے ساتھ۔ نیچے کی جدول میں ہر دن درج ہے۔',
    current: 'یہ مدت',
    previous: 'پچھلی مدت ({{from}} – {{to}})',
    currentShort: 'یہ مدت',
    previousShort: 'پچھلی مدت',
    caption: '{{count}} سے کم گفتگو والے دن روکے جاتے ہیں اور خالی جگہ کے طور پر دکھتے ہیں۔',
    table: 'اعداد جدول میں دکھائیں',
    date: 'دن',
  },
  reasons: {
    title: 'گفتگو انسان کو کیوں منتقل ہوئی',
    empty: 'اس مدت میں کوئی منتقلی نہیں۔',
    reason: 'وجہ',
    count: 'گفتگو',
    names: {
      customer_request: 'گاہک نے انسان سے بات کرنا چاہی',
      ai_unavailable: 'AI ماڈل دستیاب نہیں تھا',
      ai_blocked: 'AI کا جواب روکا گیا',
      ai_limit: 'AI کی حد یا بجٹ پورا ہو گیا',
      ai_stopped: 'AI جوابات روکے گئے تھے',
      no_agent: 'کوئی AI ایجنٹ شائع نہیں تھا',
      assist_mode: 'AI صرف جوابات تجویز کرتا ہے',
      channel_ai_off: 'اس چینل پر AI جواب نہیں دیتا',
      staff_takeover: 'کسی انسان نے سنبھالا',
      staff_reply: 'کسی انسان نے جواب دیا',
      staff_assign: 'کسی انسان کو سونپی گئی',
      staff_release: 'قطار میں واپس بھیجی گئی',
      authority_assignment: 'Chatwoot میں سونپی گئی',
      authority_handoff: 'Chatwoot میں منتقل کی گئی',
      human_reply: 'Chatwoot میں کسی انسان نے جواب دیا',
      return_to_ai: 'AI کو واپس کی گئی',
      unknown: 'درج نہیں',
    },
  },
  quality: {
    title: 'جو چیٹس ٹھیک نہیں رہیں',
    description:
      'گاہک جنہوں نے لکھا اور ایک گھنٹے میں جواب نہیں ملا، کوئی جواب دینے والا نہ ہونے پر رابطہ فارم سے چھوڑے گئے پیغامات، اور بند چیٹس جو دوبارہ کھولی گئیں۔',
    missed: 'چھوٹی ہوئی چیٹس',
    missedNote: 'ان {{count}} چیٹس میں سے {{rate}} جن میں گاہک نے لکھا',
    offlineMessages: 'رابطہ فارم کے پیغامات',
    offlineMessagesNote: 'جب کوئی جواب دینے والا نہیں تھا، تب چھوڑے گئے',
    reopened: 'دوبارہ کھولنے کی شرح',
    reopenedNote: '{{count}} بند چیٹس میں سے، جو دوبارہ کھولی گئیں',
  },
  tickets: {
    title: 'ٹکٹ',
    created: 'بنائے گئے',
    createdNote: 'اس مدت میں کھولے گئے',
    closed: 'بند کیے گئے',
    closedNote: 'اس مدت میں کھلے، اور پھر بند ہوئے',
    openNow: 'ابھی کھلے',
    openNowNote: 'کھلے یا گاہک کے انتظار میں، چاہے کبھی بھی کھولے گئے ہوں',
    closeMedian: 'بند ہونے کا درمیانی وقت',
    byPriority: 'ترجیح کے لحاظ سے',
    bySource: 'ذریعے کے لحاظ سے',
    priority: 'ترجیح',
    source: 'ذریعہ',
    count: 'ٹکٹ',
    priorities: {
      urgent: 'فوری',
      high: 'زیادہ',
      medium: 'درمیانی',
      low: 'کم',
      none: 'کوئی ترجیح نہیں',
    },
    sources: {
      offline_form: 'رابطہ فارم',
      staff: 'ٹیم',
      automation: 'آٹومیشن',
      email: 'ای میل',
    },
    emptyList: 'اس مدت میں کوئی ٹکٹ نہیں۔',
    empty: {
      title: 'اس تاریخ کی حد میں کوئی ٹکٹ نہیں',
      description:
        'ٹکٹ رابطہ فارم، ای میل، آپ کی ٹیم اور آٹومیشن سے آتے ہیں۔ کوئی اور تاریخ کی حد آزمائیں۔',
    },
  },
  commerce: {
    title: 'آرڈر اور ریفنڈ',
    description: 'گفتگو میں دیے گئے آرڈر اور واپس کیے گئے ریفنڈ، ہر کرنسی کے مطابق۔',
    empty: 'اس مدت میں کوئی آرڈر یا ریفنڈ نہیں۔',
    currency: 'کرنسی',
    orders: 'آرڈر',
    revenue: 'ادا شدہ',
    refunds: 'ریفنڈ',
    refunded: 'واپس کیا گیا',
  },
  teams: {
    title: 'قطار کی کارکردگی',
    description: 'ٹیمیں، ان کی قطار کی گفتگو کے مطابق۔',
    team: 'ٹیم',
    conversations: 'گفتگو',
    firstResponse: 'پہلے جواب کا وسطانیہ',
    handoffRate: 'منتقلی کی شرح',
    feedback: 'گاہک کا فیڈبیک',
    unnamed: 'بے نام ٹیم',
    none: 'کوئی ٹیم نہیں',
  },
  channels: {
    title: 'چینل',
    channel: 'چینل',
    unknown: 'نامعلوم چینل',
  },
  replyTargets: {
    title: 'جواب کے وقت کے اہداف',
    description:
      'کسی فرد نے کتنی بار برانڈ کے جواب کے وقت کے ہدف کے اندر جواب دیا۔ ہدف تب گنا جاتا ہے جب اس کی گھڑی رکتی ہے؛ جو گھڑیاں کسی فرد کے جواب کے بغیر رکیں، وہ الگ گنی جاتی ہیں، چوکے ہوئے ہدف کے طور پر نہیں۔',
    met: 'پورے ہوئے اہداف',
    metNote: 'لوگوں کے {{count}} جوابات میں سے',
    missed: 'چوکے ہوئے اہداف',
    missedNote: 'ہدف کے بعد آنے والے جوابات',
    firstReply: 'پہلے جواب تک کا درمیانی وقت',
    firstReplyNote: 'کام کا وقت، اسنوز کا وقت چھوڑ کر۔ ناپے گئے جوابات: {{count}}',
    stopped: 'جواب کے بغیر رکیں',
    stoppedNote: 'AI نے چیٹ واپس لے لی، یا وہ حل ہو گئی',
    byPriority: 'ترجیح کے لحاظ سے',
    byDay: 'دن کے لحاظ سے',
    replies: 'جوابات',
    metShare: 'پورے ہوئے',
    none: 'اس مدت میں جواب کے وقت کی کوئی گھڑی نہیں رکی۔',
    recordingSince: 'جواب کے وقت کے اہداف {{date}} سے درج کیے جا رہے ہیں۔',
    notRecorded:
      'ابھی کچھ درج نہیں ہوا۔ نتائج تب دکھیں گے جب کوئی فرد ایسی گفتگو میں جواب دے گا جس کا جواب کے وقت کا ہدف ہو۔',
  },
  offers: {
    title: 'ایک وقت میں ایک فرد کو پیش کی گئی چیٹس',
    description:
      'اس مدت میں کی گئی پیشکشیں: قبول کی گئیں، رد کی گئیں یا جن کا وقت ختم ہوا، لوگوں نے کیوں رد کیا، اور وہ ہینڈ آف جو کسی نے نہیں لیے۔',
    accepted: 'قبول کی گئیں',
    acceptedNote: 'جواب دی گئی یا وقت ختم ہونے والی {{count}} پیشکشوں میں سے',
    declined: 'رد کی گئیں',
    expired: 'وقت ختم ہوا',
    acceptTime: 'قبول کرنے کا درمیانی وقت',
    acceptTimeNote: 'قبول کی گئی پیشکشیں: {{count}}',
    leftInQueue: 'قطار میں رہ گئیں',
    leftInQueueNote: '{{count}} میں سے وہ ہینڈ آف جو کسی نے قبول نہیں کیے',
    declineReasons: 'لوگوں نے کیوں رد کیا',
    reason: 'وجہ',
    declinedCount: 'رد کی گئی پیشکشیں',
    noDeclines: 'اس مدت میں کوئی پیشکش رد نہیں ہوئی۔',
    reasons: {
      at_capacity: 'بہت زیادہ چیٹس',
      not_my_area: 'ان کا شعبہ نہیں',
      going_offline: 'آف لائن جا رہے تھے',
      other: 'کچھ اور',
    },
    byTeam: 'ٹیم کے لحاظ سے',
    offered: 'پیشکشیں',
    none: 'اس مدت میں کوئی چیٹ پیش نہیں کی گئی۔',
    windowLimited: 'پیشکشیں 90 دن رکھی جاتی ہیں، اس لیے اس مدت کے پرانے دن نہیں گنے گئے۔',
  },
  aiDrafts: {
    title: 'جائزے کے لیے AI مسودے',
    description:
      'AI نے بھیجنے سے پہلے کسی فرد کے جانچنے کے لیے جو مسودے لکھے، اور لوگوں نے ان کے ساتھ کیا کیا۔',
    sent: 'بھیجے گئے',
    sentNote: 'جیسے لکھے تھے ویسے یا ترمیم کے بعد منظور، {{count}} طے شدہ مسودوں میں سے',
    edited: 'بھیجنے سے پہلے ترمیم شدہ',
    rejected: 'رد کیے گئے',
    rejectReasons: 'مسودے کیوں رد کیے گئے',
    setAsideReasons: 'مسودے کیوں ایک طرف رکھے گئے',
    reason: 'وجہ',
    drafts: 'مسودے',
    noRejects: 'اس مدت میں کوئی مسودہ رد نہیں ہوا۔',
    noSetAside: 'اس مدت میں کوئی مسودہ ایک طرف نہیں رکھا گیا۔',
    rejectNames: {
      inaccurate: 'وہ غلط تھا',
      incomplete: 'کچھ رہ گیا تھا',
      wrong_tone: 'لہجہ درست نہیں تھا',
      not_needed: 'جواب کی ضرورت نہیں تھی',
      other: 'کچھ اور',
    },
    setAsideNames: {
      customer_wrote: 'گاہک نے پھر لکھا',
      owner_changed: 'گفتگو کسی اور کے پاس چلی گئی',
      answered: 'کسی نے خود جواب دیا',
      replaced: 'ایک نئے مسودے نے اس کی جگہ لی',
      resolved: 'گفتگو حل ہو گئی',
    },
    byAgent: 'AI ایجنٹ کے لحاظ سے',
    agent: 'AI ایجنٹ',
    unknownAgent: 'کوئی ایجنٹ درج نہیں',
    none: 'اس مدت میں کوئی مسودہ نہیں لکھا گیا۔',
    windowLimited: 'مسودے 90 دن رکھے جاتے ہیں، اس لیے اس مدت کے پرانے دن نہیں گنے گئے۔',
  },
  ai: {
    replies: 'AI جوابات',
    tokens: 'AI ٹوکن',
    tokensSplit: 'ان پٹ {{input}} · آؤٹ پٹ {{output}}',
    limitHandoffs: 'حد پر انسان کو منتقل',
    limitHandoffsNote: 'وہ گفتگو جو AI نہیں لے سکا کیونکہ پلان یا بجٹ پورا ہو گیا تھا۔',
    cache: 'جوابات کیش کی کامیابی کی شرح',
    notMeasured: 'ناپا نہیں گیا',
    notMeasuredNote:
      'جوابات کیش برانڈ اور دن کے مطابق گنتا ہے؛ یہاں کوئی تلاش نہیں ہوئی، یا یہ منظر ٹیم یا چینل کے مطابق ہے۔',
    cacheNote: 'کیش سے جواب پانے والے ابتدائی سوالات کا حصہ (فی برانڈ، UTC دن)۔',
  },
  empty: {
    title: 'اس مدت میں کوئی سرگرمی نہیں',
    description: 'کوئی اور مدت آزمائیں یا فلٹر ہٹائیں۔',
    reset: 'تاریخیں اور فلٹر ری سیٹ کریں',
  },
  billing: {
    loading: 'بلنگ لوڈ ہو رہی ہے',
    plan: 'پلان: {{plan}}، {{price}} ماہانہ۔',
    noPlan: 'اس ورک اسپیس کو کوئی پلان نہیں دیا گیا، اس لیے کچھ بھی محدود نہیں۔',
    alerts: 'اس مدت کے الرٹس',
    alert: '{{limit}} {{date}} کو {{threshold}}% تک پہنچا۔',
    usedOf: '{{max}} میں سے {{used}}',
    usedUnlimited: '{{used}} استعمال، کوئی حد نہیں',
    meterLabel: '{{limit}} کا استعمال',
    perPeriod: 'یہ بلنگ مہینہ (UTC)۔',
    inUse: 'ابھی استعمال میں۔',
    limits: {
      conversations: 'گفتگو',
      aiReplies: 'AI جوابات',
      aiTokens: 'AI ٹوکن',
      knowledgeStorageBytes: 'نالج اسٹوریج',
      seats: 'نشستیں',
      webhookEndpoints: 'ویب ہُک اینڈ پوائنٹس',
    },
    states: {
      unlimited: 'کوئی حد نہیں',
      ok: 'حد کے اندر',
      warning: 'حد کے قریب',
      reached: 'حد پوری',
    },
    pastDue: {
      title: 'ایک انوائس واجب الادا ہے',
      description: 'براہ کرم ادائیگی کریں، یا ادائیگی ہو چکی ہو تو Hamnivo سے رابطہ کریں۔',
    },
    aiPaused: {
      plan_replies:
        'اس مہینے کے لیے پلان کے AI جوابات پورے ہو گئے ہیں۔ نئی گفتگو اگلے مہینے یا بڑے پلان تک لوگوں کو جاتی ہے۔',
      plan_tokens:
        'اس مہینے کے لیے پلان کے AI ٹوکن پورے ہو گئے ہیں۔ نئی گفتگو اگلے مہینے یا بڑے پلان تک لوگوں کو جاتی ہے۔',
      budget_tokens:
        'اس مہینے کا آپ کا AI بجٹ پورا ہو گیا ہے۔ نئی گفتگو تب تک لوگوں کو جاتی ہے جب تک آپ بجٹ نہ بڑھائیں یا مہینہ ختم نہ ہو۔',
    },
    usage: {
      title: 'ورک اسپیس کا استعمال',
      period: 'بلنگ مہینہ {{from}} سے {{to}} تک۔',
    },
    budget: {
      title: 'AI بجٹ',
      description:
        'AI ٹوکن پر اپنی ماہانہ حد مقرر کریں، پلان سے کم۔ حد پر AI رک جاتا ہے اور گفتگو لوگوں کو جاتی ہے۔',
      tokens: 'ماہانہ AI ٹوکن بجٹ',
      tokensHint: 'پلان کے علاوہ کوئی بجٹ نہ رکھنے کے لیے خالی چھوڑیں۔',
      alerts: 'مجھے الرٹ کریں',
      threshold: '{{value}}%',
      save: 'بجٹ محفوظ کریں',
      saved: 'بجٹ محفوظ ہو گیا۔',
      readOnly: 'بجٹ صرف بلنگ سنبھالنے والے لوگ بدل سکتے ہیں۔',
    },
    invoices: {
      title: 'انوائسز',
      empty: 'ابھی کوئی انوائس نہیں۔',
      number: 'انوائس',
      period: 'مہینہ',
      total: 'کُل',
      status: 'حالت',
      due: 'واجب الادا تاریخ',
      view: 'دیکھیں',
      viewLabel: 'انوائس {{number}} دیکھیں',
      statuses: {
        draft: 'مسودہ',
        issued: 'جاری',
        paid: 'ادا شدہ',
        void: 'منسوخ',
      },
      overdue: 'واجب الادا',
      paymentFailed: 'ادائیگی ناکام',
      paidOn: '{{date}} کو ادا ہوا',
    },
    invoice: {
      title: 'انوائس {{number}}',
      loading: 'انوائس لوڈ ہو رہا ہے',
      period: '{{plan}} پلان، {{from}} سے {{to}} تک۔',
      item: 'مد',
      quantity: 'مقدار',
      amount: 'رقم',
      planLine: '{{plan}} پلان',
      meteredLine: 'شامل {{included}} کے بعد {{limit}}',
      total: 'کُل {{amount}}',
      taxNote: 'ٹیکس شامل نہیں ہیں۔',
    },
  },
};
